export default __webpack_public_path__ + "static/media/XSYN-Privacy-Policy.0eabe616.pdf";